import {
  doc,
  Firestore,
  onSnapshot,
  updateDoc,
} from 'firebase/firestore';
import { isRecord } from '../utils/isRecord';

export interface TryoutCoach {
  id: string;
  name: string;
  tabbedAthletes: string[];
}

export function parseTryoutCoachDoc(id: string, data: unknown): TryoutCoach {
  const rec = isRecord(data) ? data : {};
  return {
    id,
    name: typeof rec.name === 'string' ? rec.name : 'Coach',
    tabbedAthletes: parseTabbedAthletes(rec.tabbedAthletes),
  };
}

export function parseTabbedAthletes(val: unknown): string[] {
  if (!Array.isArray(val)) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const item of val) {
    if (typeof item !== 'string') continue;
    const id = item.trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}

export function subscribeTryoutCoach(
  db: Firestore,
  tryoutId: string,
  coachUid: string,
  onCoach: (coach: TryoutCoach | null) => void,
  onError: (error: Error) => void,
): () => void {
  const coachRef = doc(db, 'tryouts', tryoutId, 'coaches', coachUid);
  return onSnapshot(
    coachRef,
    (snap) => {
      if (!snap.exists()) {
        onCoach(null);
        return;
      }
      onCoach(parseTryoutCoachDoc(snap.id, snap.data()));
    },
    (err) => onError(err as Error),
  );
}

export async function setCoachTabbedAthletes(
  db: Firestore,
  tryoutId: string,
  coachUid: string,
  tabbedAthletes: string[],
): Promise<void> {
  const coachRef = doc(db, 'tryouts', tryoutId, 'coaches', coachUid);
  const deduped = parseTabbedAthletes(tabbedAthletes);
  await updateDoc(coachRef, { tabbedAthletes: deduped });
}
